import { useTranslation } from 'react-i18next'
import { formatCurrency } from '../../../../domain/vos/format-currency'
import { CardInfoBox } from '../../../components/card-info-box'
import { LoadingCard } from '../../../components/loading-card'

type TotalScheduledProps = {
  amount?: number
  isLoading: boolean
}

export const TotalScheduled = ({ isLoading, amount }: TotalScheduledProps) => {
  const { t } = useTranslation()

  if (isLoading) {
    return <LoadingCard />
  }

  return (
    <CardInfoBox
      title={t('smartInstallmentsSummaries.totalScheduled.title')}
      description={t('smartInstallmentsSummaries.totalScheduled.description')}
      current={formatCurrency(amount ?? 0)}
    />
  )
}
